import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FormaPagoService {
  private apiUrl =  `${environment.apiUrl}/api/forma_pago`; 


  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse): Observable<never> {
    let mensaje = 'Error inesperado';
    if (error.error?.message) mensaje = error.error.message;
    console.error('❌ Error:', mensaje);
    return throwError(() => new Error(mensaje));
  }

  getFormasPago(): Observable<any> {
    return this.http.get<any>(this.apiUrl, { withCredentials: true }).pipe(catchError(this.manejarError));
  }

  crearFormaPago(descripcion: string): Observable<any> {
    return this.http.post<any>(this.apiUrl, { descripcion }).pipe(catchError(this.manejarError));
  }

  actualizarFormaPago(id: number, descripcion: string, estado: number): Observable<any> {
    return this.http
      .put<any>(`${this.apiUrl}/${id}`, { descripcion, estado })
      .pipe(catchError(this.manejarError));
  }

  eliminarFormaPago(id: number): Observable<any> {
    return this.http
      .delete<any>(`${this.apiUrl}/${id}`)
      .pipe(catchError(this.manejarError));
  }
}
